/**
 * Enum Loại hình đơn vị
 */
export default {
    /**
     * Sở tài chính
     */
    STC: 1,

    /**
     * Phòng tài chính
     */
    PTC: 2,

    /**
     * Đơn vị cấp xã
     */
    Xa: 3,

    /**
     * Đơn vị sự nghiệp
     */
    SuNghiep: 4,

    /**
     * Đơn vị chủ quản sự nghiệp
     */
    ChuQuanSuNghiep: 5
};
